import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import IPSDialog from '../picker/dialog';
import DialogFactory from '../picker/dialogFactory';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import importBatchSet from '@/views/components/importBatchSet';
import { noop } from '@/util';
import validateParams from '@/library/utils/paramFilter';
import { Functions } from '@/library/utils/functions';

declare interface sortList {
  productCode?: string;
  sort?: number;
}
@DialogFactory
@Component({
  mixins: [style],
  components: {},
})
export default class SelectGoods extends IPSDialog {
  // 是否是多选
  multiple = true;
  // 是否显示版单号
  showBD = true;
  // 最多选择
  max = 150;

  title = '选择商品';
  width = '590px';

  select = 1;

  keywords = '';

  confirm = false;

  searchLoading = false;

  goodsList: any[] = [];

  // 未检索到的code
  notFoundCodes = '';

  empCode = '';

  siteId = 0; // 网点ID，isCloudMall=1时必填

  isCloudMall; // 0镜像店模式、1云商城模式，云商城模式必填

  sortList: Array<sortList> = [];

  // 错误图片
  public errorImg: any = require('../../../../static/img/boxBgImg.svg');

  get placeholderText() {
    return !this.multiple ? `请输入精确商品${this.select === 2 ? '版单' : '货'}号` : `请输入${this.select === 2 ? '版单' : '货'}号，多个${this.select === 2 ? '版单' : '货'}号(最多${this.max}) 请用逗号隔开`;
  }

  get excelHeader() {
    return this.isCloudMall
      ? [
        { header: `商品货号(最多${this.max})`, key: 'productCode', width: 45 },
        { header: '排序', key: 'sort', width: 45 },
      ]
      : [{ header: `商品货号(最多${this.max})`, key: 'productCode', width: 45 }];
  }

  // 返回参数
  getResults() {
    return {
      list: this.goodsList,
      type: this.select,
    };
  }

  searchGoods() {
    if (!this.keywords) {
      this.$message.error(`请输入${this.select === 2 ? '版单' : '货'}号`);
      return;
    }
    if (!this.multiple && (this.keywords.includes(',') || this.keywords.includes('，'))) {
      this.$message.error(`请输入单个${this.select === 2 ? '版单' : '货'}号`);
      return;
    }
    let productCodes: string;
    if (this.multiple) {
      productCodes = Array.from(
        new Set(
          this.keywords
            .trim()
            .replaceAll('，', ',')
            .split(',')
            .filter((item) => {
              return !!item.trim();
            })
            .map((v) => {
              v = v.trim();
              return v;
            }),
        ),
      )
        .slice(0, this.max)
        .join(',');
    } else {
      productCodes = this.keywords;
    }

    if (!productCodes) {
      this.$message.error('请输入正确货号');
      return;
    }

    this.searchLoading = true;

    // 是否是多个货号 单个货号传productCode 多个传productCodes 根据 , 判断
    const isCodes = productCodes.includes(',');
    const postParams = {
      siteId: this.siteId,
      isCloudMall: this.isCloudMall,
    };
    postParams[`productCode${isCodes ? 's' : ''}`] = productCodes;
    (this.select === 1 ? IPSService.adminComBatchFindProducts({ postParams }) : IPSService.adminComBatchFindBDProducts({ postParams: { bdCodes: productCodes, isDetail: 1 } })).then(
      (res) => {
        this.notFoundCodes = res.notFoundCodes;

        const list = (res.list || []).map((i: any) => {
          if (this.select === 1) {
            i.productOriginPrice = i.originPrice === undefined ? (i.skuItems[0] ? i.skuItems[0].originPrice : 0) : i.originPrice;
            return i;
          } else {
            i.open = true;
            i.brProducts.map((v) => {
              v.productOriginPrice = v.skuItems && v.skuItems.length ? v.skuItems[0].originPrice : 0;
              return v;
            });
            return i;
          }
        });
        if (this.sortList && this.sortList.length && this.isCloudMall) {
          this.sortList.map((v) => {
            this.goodsList = list.map((i: any) => {
              if ((`${i.productCode}`).toLowerCase() == (`${v.productCode}`).toLowerCase()) {
                i.sort = v.sort;
              }
              return i;
            });
          });
          this.sortList = [];
        } else {
          this.goodsList = list;
        }
        this.searchLoading = false;
        if (this.goodsList.length) {
          this.confirm = true;
        }
      },
      () => {
        this.searchLoading = false;
      },
    );
  }

  onGetGoodsList = (e?) => {
    if (e && e.keyCode !== 13) {
      return;
    }
    this.searchGoods();
  };

  onSelectChange() {
    this.goodsList = [];
    this.notFoundCodes = '';
  }

  // 导入查询
  importSearch() {
    let productCodes = [];
    if (this.multiple) {
      productCodes = Array.from(
        new Set(
          this.keywords
            .trim()
            .replaceAll('，', ',')
            .split(',')
            .filter((item) => {
              return !!item.trim();
            })
            .map((v) => {
              v = v.trim();
              return v;
            }),
        ),
      )
        .slice(0, this.max)
        .map((p) => {
          return {
            productCode: p,
          };
        });
    }

    importBatchSet
      .open({
        title: '导入查询',
        fromKey: 'goods',
        postParams: {},
        empCode: this.empCode,
        data: productCodes,
        excelHeader: this.excelHeader,
        name: '商品选择',
        isCloudMall: this.isCloudMall,
      })
      .then((result) => {
        if (result.flag) {
          this.keywords = this.isCloudMall ? result.result.map(i => i.productCode).join(',') : result.result.splice(0, this.max).join(',');
          this.sortList = this.isCloudMall
            ? result.result.map((i) => {
              return { productCode: i.productCode, sort: i.sort };
            })
            : [];
          this.searchGoods();
        }
      }, noop);
  }

  renderSearch(h) {
    return (
      <div class="search">
        <div class="search-wrap">
          <el-select v-model={this.select} class="el-select" disabled={!this.showBD} onChange={this.onSelectChange.bind(this)}>
            <el-option label="货号" value={1} />
            <el-option label="版单号" value={2} />
          </el-select>
          <el-input
            v-model={this.keywords}
            className="input-search"
            placeholder={this.placeholderText}
            maxlength="1000"
            nativeOn-keyup={(e) => {
              this.onGetGoodsList(e);
            }}
          />
          <el-button type="primary" onClick={() => this.onGetGoodsList()}>
            检索
          </el-button>
          {this.multiple && (
            <span class="scopeSpan r-pl-12 no-wrap wid-55" onClick={this.importSearch.bind(this)}>
              导入查询
            </span>
          )}
        </div>
        {this.notFoundCodes && (
          <p class="tip blockTip" style="height: auto !important">
            <span class="redText">*&nbsp;</span>
            {`${this.select === 2 ? '版单' : '货'}号${this.notFoundCodes}未检索到商品`}
          </p>
        )}
      </div>
    );
  }

  renderGoodsList(h) {
    return (
      <div class="goodsList">
        {this.goodsList.map((item, index) => {
          return (
            <div class="goodsProfile">
              <img class="goodsPic" src={item.productImage || this.errorImg} />
              <div class="goodsInfo">
                <div class="goodsTitle" title={item.productName}>
                  {item.productName}
                </div>
                <div class="goodsCode">{item.productCode}</div>
                <div class="goodsPrice">
                  牌价
                  <i>￥{item.productOriginPrice}</i>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  renderBDGoodsList(h) {
    return (
      <div class="goodsList">
        {this.goodsList.map((item) => {
          return [
            <p
              class="bdCode"
              onClick={() => {
                item.open = !item.open;
              }}>
              <span>{item.bdCode}</span> <i class="el-icon-arrow-down iconfont" style={{ transform: `rotate(${item.open ? 0 : 180}deg)`, transition: 'transform 0.2s linear' }} />
            </p>,
            item.open
              && item.brProducts
              && item.brProducts.map((i, index) => {
                return (
                  <div class="goodsItem">
                    <div class="goodsIndex">{index + 1}</div>
                    <div class="goodsInfoWrapper">
                      <div class="goodsProfile">
                        <img class="goodsPic" src={i.productImage || this.errorImg} />
                        <div class="goodsInfo">
                          <div class="goodsTitle" title={i.productName}>
                            {i.productName}
                          </div>
                          <div class="goodsCode">{i.productCode}</div>
                          <div class="goodsPrice">
                            牌价
                            <i>￥{i.productOriginPrice}</i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }),
          ];
        })}
      </div>
    );
  }

  renderContent(h) {
    return (
      <div class="select-goods" v-loading={this.searchLoading}>
        {this.renderSearch(h)}
        {this.select === 1 ? this.renderGoodsList(h) : this.renderBDGoodsList(h)}
      </div>
    );
  }
}
